import axios from 'axios'

const torrents = {
  search (query, category, tracker, page, sort, order, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/search',
      {
        'query': query,
        'category': category,
        'tracker': tracker,
        'page': page,
        'sort': sort,
        'order': order,
      }
    )
    this.handleResponse(promise, cb)
  },

  get_user_info (cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/get-user',
      {
        params: {username: localStorage.getItem('username')},
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResponse(promise, cb)
  },

  download (username, url, passkey, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/torrent/download',
      { 'username': username,
        'url': url,
        'passkey': passkey,
      },
      {'headers':
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResponse(promise, cb)
  },

  handleResponse(promise, cb) {
    promise.then((resp) => {
      cb(resp)
    }).catch((error) => cb([]))
  },
}

export default torrents
